import React, { useState } from 'react';
import ReactDOM from 'react-dom';



// These imports won't work until you fix ./components/index.js
import {
  //Feature,
  Loading,
  Preview,
  Search,
  Title
} from './components';

const App = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchResults, setSearchResults] = useState({info: {}, records: []});
  const [featuredResult, setFeaturedResult] = useState (null);

  /**
   * We are at the App level component, which is top-most. Any state which needs to be shared between immediate children should
   * be made here, so create state pairs using useState() for:
   * 
   * searchResults, setSearchResults (default should be this object:  {info: {}, records: []} )
   * featuredResult, setFeaturedResult (default should be null)
   * isLoading, setIsLoading (default should be false)
   */

  return <div className="app">
     <Title /> 
    {/* <Search /> needs props for setIsLoading and setSearchResults (trigger <Loading /> on search start/end, and transfer results to preview) */}
    <Search setIsLoading = {setIsLoading} setSearchResults = {setSearchResults}/>
    <Preview searchResults = {searchResults} setIsLoading = {setIsLoading} setSearchResults = {setSearchResults} setFeaturedResult = {setFeaturedResult}/>
    {/* <Preview /> */}
    {/* <Feature /> needs props for featuredResult, as well as setIsLoading and setSearchResults (clicking on searchable properties) */}
    {/* <Feature />*/}
    {isLoading ? <Loading /> : null} 
    {/* <Loading /> use a ternary and render null if isLoading is false */}
  </div> 
}

/**
 * Boostrap the <App /> component into the '#app' element in the DOM,
 * using ReactDOM.render();
 */
 ReactDOM.render(<App />, document.getElementById('app'));

 
 